import "./App.css";
import "./style.scss";
import Router from "./Routes";
import { useCallback, useEffect } from "react";
import { firebaseCloudMessaging } from "./utils/firebase";
import { useNavigate } from "react-router-dom";
import { getData } from "./constants";
import { STORAGE_KEYS, storeData } from "./constants/storage";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useLazyGetSadminDataQuery } from "./services/api";
import { setCredentials, setRolePermission } from "./reducers/authSlice";
import usePermission from "./hooks/usePermission";

function App() {
  const dispatch = useDispatch();
  const [getProfileMethod] = useLazyGetSadminDataQuery();
  const useRole = usePermission();

  useEffect(() => {
    // Calls the getMessage() function if the token is there
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          console.log("fcm_Token::::::::::::::", fcmToken);
        }
      } catch (error) {
        console.log(error);
      }
    }

    setToken();
    // Event listener that listens for the push notification event in the background
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        try {
          event?.source?.postMessage("Hi client");
          console.log("event for the service worker", event);
          return toast(
            <div style={{ height: "100%" }}>
              <div>{event?.data?.notification?.title}</div>
              <div>{event?.data?.notification?.body}</div>
            </div>
          );
          return event;
        } catch (e) {
          console.log(e, "error");
          return e;
        }
      });
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", (e) =>
          console.log(e)
        );
      }
    };
  }, []);

  const getProfileData = useCallback(
    async (token) => {
      try {
        if (!token) {
          return;
        }
        const res = await getProfileMethod();
        storeData(STORAGE_KEYS?.userData, res?.data?.data);
        dispatch(
          setCredentials({
            user: res?.data?.data || null,
            token: token || null,
          })
        );
      } catch (error) {
        console.error("Error getting profile data:", error);
      }
    },
    [dispatch, getProfileMethod]
  );

  useEffect(() => {
    const checkToken = async () => {
      try {
        const token = getData(STORAGE_KEYS.token);
        const data = getData(STORAGE_KEYS.userData);
        const rolePermission = getData(STORAGE_KEYS.rolePermission);
        if (!useRole) {
          dispatch(
            setRolePermission({
              rolePermission: rolePermission,
            })
          );
        }
        console.log("rolePermission: ", rolePermission);
        if (token && data) {
          dispatch(
            setCredentials({
              user: data,
              token: token,
            })
          );
        } else {
          await getProfileData(token);
        }
      } catch (error) {
        console.error("Error checking token:", error);
      }
    };

    checkToken();
  }, [dispatch, getProfileData, useRole]);

  return (
    <>
      <Router />
    </>
  );
}

export default App;
